import React, { memo, Fragment } from "react";

import { Icon } from "src/primitives";

import styles from "./style.css";

const Menu = memo(props => {
  const { navControls = {}, hide } = props;
  const { value = [], logoFile, backgroundColor, ribbonBackgroundColor, dropdownTextColor, dropdownBackgroundColor } = navControls;

  return (
    <Fragment>
      <div class={styles.overlay} onClick={hide} />
      <div class={styles.links} style={{ background: backgroundColor }}>
        <header>
          <img src={logoFile} />
          <a onClick={hide} style={{ color: dropdownTextColor }}>
            <Icon name="close" />
          </a>
        </header>
        {value.map((icon, i) => (
          <a key={i} href={icon.url} style={{ color: dropdownTextColor, background: dropdownBackgroundColor || ribbonBackgroundColor }}>
            <span dangerouslySetInnerHTML={{ __html: icon.svg }} />
            {icon.ribbonText}
          </a>
        ))}
      </div>
    </Fragment>
  );
});

export default Menu;
